import { useMemo } from "react";

type Partner = {
  id: string;
  name: string;
  slug: string;
  parent: string;
  gcp_project_id: string;
};

// Define the type if using TypeScript
type User = {
  id: string;
  email: string;
  recovery_email: string;
  first_name: string;
  last_name: string;
  partners: Partner[];
};

// Read from the global `window.data`, or provide a default
const configFromWindow = (window as any).data.user || false;

export default (): User => {
  return useMemo(() => configFromWindow, []);
};
